import * as Yup from 'yup'
import { AuthFormModel } from './formModels'

const {
  formFields: { shippingNo, username, password, keep },
} = AuthFormModel

const validationSchema = Yup.object({
  [shippingNo.Name]: Yup.string().required(shippingNo.errorMsg.required),
  [username.Name]: Yup.string().required(username.errorMsg.required),
  [password.Name]: Yup.string().required(password.errorMsg.required),
  [keep.Name]: Yup.boolean(),
})

export default validationSchema
